/**
 * Firebase initialization — single app instance shared across the app.
 * Config from Firebase Console project vscm-7a05a.
 */
import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
const firebaseConfig = {
  apiKey: 'AIzaSyDu0zkC63rFdqnTbYHV4pVA43TmweaN2lo',
  authDomain: 'vscm-7a05a.firebaseapp.com',
  projectId: 'vscm-7a05a',
  storageBucket: 'vscm-7a05a.firebasestorage.app',
  messagingSenderId: '863005843803',
  appId: '1:863005843803:web:c202000ac61f0089553a7e',
  measurementId: 'G-J36RJH99FD',
}

// Prevent duplicate initialization in HMR / StrictMode
const app: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApp()
const auth: Auth = getAuth(app)
export { app, auth }
